import { petTypeElements } from '@flows/configs/petHealthV2/steps/elements/petType'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'

const pet_type = (params: StepConfigParams) =>
  fragmentStep(petTypeElements(params), params, 'pet_birthday')

export default pet_type
